export default __webpack_public_path__ + "static/media/chevron-blue-right.3353afa1.svg";